// src/config/site.ts
export const siteConfig = {
    name: "Keep It Sorted",
    description: "Keep track of your subscriptions and expenses",
    url: "https://keepitsorted.com", // Update with your actual URL
    ogImage: "https://keepitsorted.app/og.jpg", // Update with your actual OG image
    author: "Divij Sharma"
}